import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/illustrations2/PNG/bulk_page_v-a_for_instant_large_scale_verification.png";
import MainImg2 from "../../../assets/illustrations2/PNG/bulk_page_v-a_for_scalable_processing_up_to_500k_rows.png";

export default function TestimonialOne() {
  return (
    <>
      <div>
        <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-24">
          Fast Results for{" "}
          <span className="relative inline-block">
            Big Lists{" "}
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>
        </h2>
        <div className="bg-gray-50 p-8 lg:px-20">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
            <div
              className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-2`}
            >
              <img
                src={MainImg}
                alt="Expanded section preview"
                className="md:w-full w-96"
              />
            </div>

            <div className={`text-left md:w-[55%] md:order-1 lg:mt-10 md:p-6`}>
              <p className="text-[22px] mt-6">
                On average, our service processes 1,000 rows in just 1 minute.
                Our system works quickly to keep your process hundreds or
                100,000 rows of data to keep your projects moving. Get reliable
                email data without the usual delays.
              </p>
              <p className="text-[22px] mb-6 mt-4 lg:mb-12">
                With minimized wait times, we’ve enhanced efficiency so you stay
                ahead in lead generation efforts.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-14">
          Process Up to{" "}
          <span className="relative inline-block">
            500k Emails{" "}
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>{" "}
          at Once
        </h2>
        <div className="bg-gray-50 p-8 lg:px-20">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
            <div
              className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-1`}
            >
              <img
                src={MainImg2}
                alt="Expanded section preview"
                className="md:w-full w-96"
              />
            </div>

            <div className={`text-left md:w-[55%] md:order-2 lg:mt-10 md:p-6`}>
              <p className="text-[22px] my-8 lg:mb-12">
                Our Bulk Email Finder can process over 500K rows smoothly,
                taking about 20 minutes for the largest lists. Get the emails
                you need without sacrificing speed or accuracy, no matter how
                big your database.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
